module.exports = __webpack_public_path__ + "img/Revise.d245dbb4.svg";